export type InputSize = 'medium' | 'large';

export enum InputVariant {
    DEFAULT = 'default',
    SIDEBAR ='sidebar',
}
